import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {LicenseService} from "./license.service";
import {filter, map, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LicenseGuard implements CanActivate {
  constructor(private licenseService: LicenseService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let isPatientKiosk = window.location.pathname.toLowerCase().includes('/patientkiosk');
    return this.licenseService.validateLicense(!isPatientKiosk, isPatientKiosk).pipe(map(res => {
      if (res) {
        return true;
      } else {
        this.router.navigate(['/licensenotfound', {isPatientKiosk: isPatientKiosk}]);
      }
    }));
  }
}
